import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Role, UserDto } from '@zakat/shared';

interface AuthState {
  /** Jeton d'accès : en mémoire uniquement (jamais persisté). */
  accessToken: string | null;
  expiresAt: number;
  /** Profil mis en cache pour l'affichage hors ligne. */
  user: UserDto | null;
  restored: boolean;
  setSession(token: string, user: UserDto, expiresInSeconds: number): void;
  setUser(user: UserDto): void;
  clear(): void;
  markRestored(): void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      expiresAt: 0,
      user: null,
      restored: false,
      setSession: (accessToken, user, expiresInSeconds) => set({ accessToken, user, expiresAt: Date.now() + expiresInSeconds * 1000 }),
      setUser: (user) => set({ user }),
      clear: () => set({ accessToken: null, expiresAt: 0, user: null }),
      markRestored: () => set({ restored: true }),
    }),
    { name: 'zl-auth', partialize: (s) => ({ user: s.user }) },
  ),
);

export function hasRole(user: UserDto | null, ...roles: Role[]): boolean {
  if (!user) return false;
  return user.roles.includes('super_admin') || roles.some((r) => user.roles.includes(r));
}

export const useUser = () => useAuthStore((s) => s.user);
